import { FC, PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { STUDENT_HISTORY_ROUTE, STUDENT_ROUTE, STUDENT_WALLET_HISTORY_ROUTE } from "../../../../app/router/routes";
import classes from "../card/studentWidget.module.scss";

interface IProps extends PropsWithChildren {
    studentId: number;
    selectedTab: 1 | 2 | 3;
    showHistoryTab?: boolean;
    showWalletHistoryTab?: boolean;
}

export const StudentDetailLayout: FC<IProps> = ({
    studentId,
    selectedTab,
    showHistoryTab = false,
    showWalletHistoryTab = false,
    children,
}) => {
    const navigate = useNavigate()

    const onSelected = (tab: 1 | 2 | 3) => {
        if(tab === 1){
            navigate(STUDENT_ROUTE.path.replace(':id', String(studentId)))
            return
        }

        if(tab === 2){
            navigate(STUDENT_HISTORY_ROUTE.path.replace(':id', String(studentId)))
            return
        }

        navigate(STUDENT_WALLET_HISTORY_ROUTE.path.replace(':id', String(studentId)))
    }

    const tabsCount = 1 + (showHistoryTab ? 1 : 0) + (showWalletHistoryTab ? 1 : 0)

    return (
        <section className={classes.container}>
            <section className={classes.detailTabs}>
                {(showHistoryTab || showWalletHistoryTab) && (
                    <section
                        className={classes.detailTabsGrid}
                        style={{gridTemplateColumns: `repeat(${tabsCount}, minmax(0, 1fr))`}}
                    >
                        <button
                            className={classes.detailTab + (selectedTab === 1 ? ` ${classes.detailTabActive}` : '')}
                            onClick={() => onSelected(1)}
                        >
                            Информация
                        </button>
                        {showHistoryTab && (
                            <button
                                className={classes.detailTab + (selectedTab === 2 ? ` ${classes.detailTabActive}` : '')}
                                onClick={() => onSelected(2)}
                            >
                                История изменений
                            </button>
                        )}
                        {showWalletHistoryTab && (
                            <button
                                className={classes.detailTab + (selectedTab === 3 ? ` ${classes.detailTabActive}` : '')}
                                onClick={() => onSelected(3)}
                            >
                                Изменение кошелька
                            </button>
                        )}
                    </section>
                )}
            </section>
            {children}
        </section>
    )
}
